

const Message = ({ data }) =>
{
  // I could make this pretty... but eh (ﾉ◕ヮ◕)ﾉ*:･ﾟ✧

  return (
    <div style={{ padding: "0px 0px 5px 0px", display: "block" }}>
      <div id="userName" style={{ paddingBottom: "2px" }}>
        {data.user.displayName}
      </div>
      <div id="messageBody">
        {data.message.content.split("\n").map((str, i) => <div key={i}>{!str.length ? <br /> : ""}<p style={{ margin: 0 }}>{str}</p></div>)}
      </div>
    </div>
  );
}

export default Message;
